import { Component, Input } from '@angular/core';

import { Validacao } from './validacao';
import { ValidacaoService } from './validacao.service';
import { Estudo } from '../estudo/estudo';
import { EstudoService } from '../estudo/estudo.service';
import { SituacaoEnum } from '../util/situacao.enum';
import { MatSnackBar } from '@angular/material';


@Component({
    templateUrl: './validacao.mensagem.component.html',
    selector: 'validacao-mensagem'
})
export class ValidacaoMensagemComponent {
    @Input()  public estudo : Estudo;
    @Input()  public mostrarHeader : boolean = true;
    @Input()  public mostrarDadosPessoais : boolean = true;
    @Input()  public mostrarGrupoFamiliar : boolean  = true;
    @Input()  public mostrarAbaSuperior : boolean = true;
    @Input()  public expandido : boolean = true;

    public lista : Validacao[];
    public isLoading: boolean;
    public mensagem: string = "";

    // construtor
    constructor(
      private validacaoService : ValidacaoService, private estudoService : EstudoService,
      public mensagemTela: MatSnackBar ) {   }

    // ngOnInit é executado ao entrar na tela
    public ngOnInit() {
      // atualizo o estudo soh de precaucao
      this.carregaEstudo();

    }

    private carregaEstudo(){
        if(this.estudo){
          if(this.estudo.situacao == SituacaoEnum.ParaCorrecao){
            this.carregaValidacao();
          }
      }
    }

  private carregaValidacao(){
    this.isLoading = true;
    let validacao: Validacao = new Validacao();
    validacao.codigoEstudoSocioEconomico = this.estudo.id;
    this.validacaoService.filtrar(validacao).subscribe((results: Validacao[])=> {
        this.mensagem =   this.montarMensagemValidacao(results);
      },
      error =>  this.erro(error)
    );
  }


  /**
  Carrega as mensagem de um estudo avaliado
  **/
  public montarMensagemValidacao(lista: Validacao[]): string {
    let mensagem = '';
    let todosCorrigidos: boolean = true;

    if (lista != null && lista.length >0) {

      let primeiraVez: boolean = true;
      lista.forEach((validacao:Validacao) => {

        if (!validacao.corrigido) {
          todosCorrigidos = false;
          let aba = "";
          if (this.mostrarAbaSuperior) {
            if (primeiraVez) {
              primeiraVez = false;
            } else {
              aba = "</div>";
            }
            if (validacao.codigoGrupoFamiliar) {
              aba += "<h5>4. DADOS DO GRUPO FAMILIAR. "
            } else {
              aba += "<h5>3. DADOS PESSOAIS. ";
            }
          } else {
            aba += "<h5>";
          }
          if ((this.mostrarGrupoFamiliar && validacao.codigoGrupoFamiliar) || (this.mostrarDadosPessoais && !validacao.codigoGrupoFamiliar)) {
            mensagem += aba +
             validacao.perguntaIdentificacao +
             "</span>" +
              " </h5> " +
                "<div class='col-lg-12 col-md-12 col-sm-12 col-xs-12'>"+
                  "<label>Pergunta: </label>" + validacao.perguntaEnunciado + "<br>" +
                  "<label>Correção: </label></h2>" + validacao.descricao + "<br> <br>" +
                 "</div>";

          }

        }

      });

      if (mensagem != '') { //  quero adicionar essa mensage somente no final.

        mensagem = "<div class='alert alert-danger'>Sempre salve as alterações antes de ir pra próxima Seção. Após concluir as correções, acessar a Seção '5. CONCLUSÃO' e clicar no botão 'Concluir'</div>" + mensagem;

      }

    } else {

      mensagem =  null;

    }
    this.isLoading = false;
    return mensagem;

  }

    // mostra erros na tela
  private erro(erro: string) {
    this.mensagemTela.open(erro, 'X', {duration: 5000});
    this.isLoading = false;
  }

   // finaliza o subscribe
  private finaliza(){
    this.isLoading =false;
  }

}
